module.exports = __webpack_public_path__ + "img/sintomas ponto colheita.9ef2e3df.webp";